(function () {
  var MONEY_PATTERN = '((?:\\d{1,3}(?:\\.\\d{3})*|\\d+)[,.]\\d{2})\\s*\\u20ac';
  var PRICE_SEQUENCE = new RegExp(MONEY_PATTERN + '\\s*' + MONEY_PATTERN + '\\s*(\\((?:Ahorra|Save|Savings)[^)]+\\))', 'i');

  function parseMoney(text) {
    var match = String(text || '').match(new RegExp(MONEY_PATTERN, 'i'));
    return match ? parseFloat(match[1].replace(/\./g, '').replace(',', '.')) : null;
  }

  function looksLikeSavings(text) {
    return /ahorra|save|savings|discount/i.test(String(text || ''));
  }

  function makePriceSpan(text, attribute) {
    var span = document.createElement('span');
    span.textContent = text.trim();
    span.setAttribute(attribute, 'true');
    return span;
  }

  function rewriteInlinePriceText(textNode) {
    var text = textNode.nodeValue;
    var match = text.match(PRICE_SEQUENCE);

    if (!match || textNode.parentElement.dataset.delamurPriceSorted === 'true') return false;

    var firstPrice = match[1] + ' \u20ac';
    var secondPrice = match[2] + ' \u20ac';
    var saving = match[3];
    var firstValue = parseMoney(firstPrice);
    var secondValue = parseMoney(secondPrice);
    var currentPrice = firstValue <= secondValue ? firstPrice : secondPrice;
    var comparePrice = firstValue <= secondValue ? secondPrice : firstPrice;
    var before = text.slice(0, match.index);
    var after = text.slice(match.index + match[0].length);
    var row = document.createElement('span');

    row.setAttribute('data-delamur-price-row', 'true');
    row.appendChild(makePriceSpan(currentPrice, 'data-delamur-current-price'));
    row.appendChild(makePriceSpan(comparePrice, 'data-delamur-compare-price'));
    row.appendChild(makePriceSpan(saving, 'data-delamur-saving-price'));

    var fragment = document.createDocumentFragment();
    if (before) fragment.appendChild(document.createTextNode(before));
    fragment.appendChild(row);
    if (after) fragment.appendChild(document.createTextNode(after));

    textNode.parentNode.replaceChild(fragment, textNode);
    row.parentElement.dataset.delamurPriceSorted = 'true';
    return true;
  }

  function sortPriceNodes(row) {
    if (!row || row.dataset.delamurPriceSorted === 'true') return;

    var nodes = Array.from(row.children).filter(function (node) {
      return node.textContent && node.textContent.match(/\d+[,.]\d{2}\s*\u20ac|ahorra|save|savings/i);
    });

    if (nodes.length < 2) return;

    var moneyNodes = nodes.filter(function (node) {
      return parseMoney(node.textContent) !== null && !looksLikeSavings(node.textContent);
    });
    var savingNodes = nodes.filter(function (node) {
      return looksLikeSavings(node.textContent);
    });

    if (moneyNodes.length < 2) return;

    moneyNodes.sort(function (a, b) {
      return parseMoney(a.textContent) - parseMoney(b.textContent);
    });

    var current = moneyNodes[0];
    var compare = moneyNodes[moneyNodes.length - 1];

    current.dataset.delamurCurrentPrice = 'true';
    compare.dataset.delamurComparePrice = 'true';

    savingNodes.forEach(function (node) {
      node.dataset.delamurSavingPrice = 'true';
    });

    row.dataset.delamurPriceRow = 'true';
    row.dataset.delamurPriceSorted = 'true';
  }

  function normalizeTextSequences(scope) {
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue.match(PRICE_SEQUENCE)) return NodeFilter.FILTER_REJECT;
        if (!node.parentElement || node.parentElement.closest('script, style, input, textarea, button')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var textNodes = [];
    var node = walker.nextNode();

    while (node) {
      textNodes.push(node);
      node = walker.nextNode();
    }

    textNodes.forEach(rewriteInlinePriceText);
  }

  function normalizeStructuredPrices(scope) {
    var candidates = scope.querySelectorAll(
      '[class*="upcart" i] [class*="price" i], [class*="upcart" i] [class*="saving" i], [class*="upcart" i] [class*="discount" i]'
    );

    candidates.forEach(function (candidate) {
      var row = candidate.parentElement;
      for (var i = 0; row && i < 4; i += 1) {
        if (row.textContent && row.textContent.match(/\d+[,.]\d{2}\s*\u20ac/) && row.textContent.match(/ahorra|save|savings/i)) {
          sortPriceNodes(row);
          return;
        }
        row = row.parentElement;
      }
    });
  }

  function normalizeUpcartPrices(root) {
    var scope = root || document;
    normalizeTextSequences(scope);
    normalizeStructuredPrices(scope);
  }

  function init() {
    normalizeUpcartPrices(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          normalizeUpcartPrices(node);
        });
      });
      normalizeUpcartPrices(document);
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
